import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../assets/logo.webp';
import { useWindowSize } from '../hooks/useWindowSize';

export function Header() {
  const [isNavOpen, setNavOpen] = useState(false);
  const [isServicesOpen, setServicesOpen] = useState(false);
  const [isMicroSaaSOpen, setMicroSaaSOpen] = useState(false);
  const { width } = useWindowSize();
  const isMobile = width !== undefined && width <= 768;

  const toggleNav = () => setNavOpen(!isNavOpen);
  const toggleServices = () => setServicesOpen(!isServicesOpen);
  const toggleMicroSaaS = () => setMicroSaaSOpen(!isMicroSaaSOpen);

  const handleLinkClick = () => {
    setNavOpen(false);
    setServicesOpen(false);
    setMicroSaaSOpen(false);
  };

  const servicesSubMenu = (
    <div className="services-dropdown">
      <a href="#consulting" className="disabled-link" onClick={(e) => e.preventDefault()}>Consulting</a>
      <div 
        className="micro-saas-menu"
        onMouseEnter={isMobile ? undefined : () => setMicroSaaSOpen(true)}
        onMouseLeave={isMobile ? undefined : () => setMicroSaaSOpen(false)}
        onClick={isMobile ? (e) => { e.preventDefault(); toggleMicroSaaS(); } : undefined}
      >
        <a href="#micro-saas" onClick={(e) => e.preventDefault()}>Micro SaaS</a>
        {isMicroSaaSOpen && (
          <div className="micro-saas-dropdown">
            <NavLink to="/salary-comparator" onClick={handleLinkClick}>Salary Comparator</NavLink>
          </div>
        )}
      </div>
    </div>
  );

  const desktopMenu = (
    <div 
      className="services-menu"
      onMouseEnter={() => setServicesOpen(true)}
      onMouseLeave={() => setServicesOpen(false)}
    >
      <a href="#services" onClick={(e) => e.preventDefault()}>Services</a>
      {isServicesOpen && servicesSubMenu}
    </div>
  );

  const mobileMenu = (
    <div className="services-menu">
      <a href="#services" onClick={(e) => { e.preventDefault(); toggleServices(); }}>Services</a>
      {isServicesOpen && servicesSubMenu}
    </div>
  );

  return (
    <header className="site-header">
      <div className="logo">
        <NavLink to="/" onClick={handleLinkClick}>
          <img src={logo} alt="Sevnis" className="responsive-img" />
        </NavLink>
      </div>
      <button className="mobile-toggle" aria-label="Toggle navigation" onClick={toggleNav}>
        ☰
      </button>
      <nav className={`main-nav ${isNavOpen ? 'nav-open' : ''}`}>
        <NavLink to="/about" onClick={handleLinkClick}>About</NavLink>
        {isMobile ? mobileMenu : desktopMenu}
        <NavLink to="/contact" onClick={handleLinkClick}>Contact</NavLink>
      </nav>
    </header>
  );
}
